// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"e_5h","wrapperDark":"e_6h","wrapperLight":"e_7h","wrapperClosed":"e_8h","html":"e_9h"};